import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { TableHead, TableHeader, TableRow } from '@/common/components/ui/table';

const GROUP_HEADER_CLASS =
  'font-bold text-foreground! text-xs! border-t border-b bg-white text-center border-warm-gray-200 border-b-warm-gray-100';

const SUB_HEADER_CLASS =
  'whitespace-nowrap text-center border-r border-r-warm-gray-200 text-foreground! text-[10px] font-semibold p-2';

const GROUP_SEPARATOR_CLASS = 'border-r-2 border-r-warm-gray-200';
const CURRENT_YEAR_SUB_HEADER_CLASS = `${SUB_HEADER_CLASS} bg-terre-100`;
const COMPARATIVE_SUB_HEADER_CLASS = `${SUB_HEADER_CLASS} bg-terre-200`;

interface ComparatorHeaderProps {
  lastYearLabel: string | ReactNode;
  currentYearLabel: string | ReactNode;
  isScrolled?: boolean;
}

const ComparatorHeader = ({
  lastYearLabel,
  currentYearLabel,
  isScrolled = false,
}: ComparatorHeaderProps) => {
  const { t } = useTranslation();

  return (
    <TableHeader
      className={`sticky top-0 z-10 bg-background transition-shadow ${isScrolled ? 'shadow-md' : ''} `}
    >
      <TableRow>
        <TableHead className="bg-white" rowSpan={2} />
        <TableHead
          colSpan={3}
          className={`${GROUP_HEADER_CLASS} ${GROUP_SEPARATOR_CLASS} border-l rounded-tl-lg`}
        >
          {lastYearLabel}
        </TableHead>
        <TableHead
          colSpan={3}
          className={`${GROUP_HEADER_CLASS} ${GROUP_SEPARATOR_CLASS} bg-terre-100`}
        >
          {currentYearLabel}
        </TableHead>
        <TableHead colSpan={2} className={`${GROUP_HEADER_CLASS} bg-terre-200`}>
          {t('renewal.comparator.comparative')}
        </TableHead>
      </TableRow>
      <TableRow className="border-b [&_th]:h-[unset]">
        <TableHead
          className={`${SUB_HEADER_CLASS} border-l border-l-warm-gray-200`}
        >
          {t('renewal.comparator.limit')}
        </TableHead>
        <TableHead className={SUB_HEADER_CLASS}>
          {t('renewal.comparator.rate')}
        </TableHead>
        <TableHead className={`${SUB_HEADER_CLASS} ${GROUP_SEPARATOR_CLASS}`}>
          {t('renewal.comparator.premium')}
        </TableHead>
        <TableHead className={CURRENT_YEAR_SUB_HEADER_CLASS}>
          {t('renewal.comparator.limit')}
        </TableHead>
        <TableHead className={CURRENT_YEAR_SUB_HEADER_CLASS}>
          {t('renewal.comparator.rate')}
        </TableHead>
        <TableHead
          className={`${CURRENT_YEAR_SUB_HEADER_CLASS} ${GROUP_SEPARATOR_CLASS}`}
        >
          {t('renewal.comparator.premium')}
        </TableHead>
        <TableHead className={COMPARATIVE_SUB_HEADER_CLASS}>
          {t('renewal.comparator.limit')}
        </TableHead>
        <TableHead className={COMPARATIVE_SUB_HEADER_CLASS}>
          {t('renewal.comparator.rate')}
        </TableHead>
      </TableRow>
    </TableHeader>
  );
};

export default ComparatorHeader;
